import { render, staticRenderFns } from "./standard-specification.vue?vue&type=template&id=18d8a57d&scoped=true&"
import script from "./standard-specification.vue?vue&type=script&lang=js&"
export * from "./standard-specification.vue?vue&type=script&lang=js&"
import style0 from "./standard-specification.vue?vue&type=style&index=0&id=18d8a57d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8a57d",
  null
  
)

export default component.exports